<script>
    import { createEventDispatcher, onMount } from 'svelte';
  
    export let reminder = null;
    export let mode = 'view'; // 'view' | 'edit'
  
    const dispatch = createEventDispatcher();
  
    // Track when the mode changes
    let previousMode = mode;
    let isFormInitialized = false;

    const timezones = [
        'UTC',
        'Europe/London',
        'Europe/Paris',
        'Europe/Berlin',
        'Europe/Madrid',
        'Europe/Rome',
        'Europe/Amsterdam',
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Los_Angeles',
        'America/Toronto',
        'America/Vancouver',
        'America/Sao_Paulo',
        'Asia/Tokyo',
        'Asia/Seoul',
        'Asia/Hong_Kong',
        'Asia/Singapore',
        'Asia/Kolkata',
        'Asia/Dubai',
        'Australia/Sydney',
        'Australia/Melbourne',
        'Pacific/Auckland'
        ];
  
    // Initialize with default values
    let localReminder = {
      frequency: 'daily',
      time_of_day: '09:00',
      day_of_week: '',
      day_of_month: '',
      custom_message: '',
      teams_webhook_url: '',
      is_active: true
    };
  
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);
  
    // Initialize form data when component mounts
    onMount(() => {
      initializeFormData();
    });
  
    // Also monitor mode changes to update form when switching to edit mode
    $: if (mode !== previousMode) {
      previousMode = mode;
      if (mode === 'edit') {
        initializeFormData();
      }
    }
  
    // Helper function to copy reminder data to localReminder
    function initializeFormData() {
      if (reminder && mode === 'edit') {
        // Create a new object to avoid reference issues
        localReminder = {
          frequency: reminder.frequency || 'daily',
          time_of_day: reminder.time_of_day || '09:00',
        //   day_of_week: reminder.day_of_week || '',
            day_of_week: typeof reminder.day_of_week === 'number'
                ? weekdays[(reminder.day_of_week + 6) % 7] // remap 0=Sunday to index 6
                : reminder.day_of_week || '',
          day_of_month: reminder.day_of_month || '',
          custom_message: reminder.custom_message || '',
          teams_webhook_url: reminder.teams_webhook_url || '',
          is_active: reminder.is_active !== undefined ? reminder.is_active : true
        };
        
        // Update timezone as well
        timezone = reminder.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        isFormInitialized = true;
      }
    }
  
    function triggerSave() {
      dispatch('save', { ...localReminder, timezone });
    }
  
    function triggerEdit() {
      dispatch('edit');
    }
  
    function triggerCancel() {
      dispatch('cancel');
    }
  </script>
  
  {#if mode === 'view'}
    {#if reminder}
      <div class="grid grid-cols-2 gap-2 text-sm">
        <div class="text-gray-500">Frequency</div>
        <div class="capitalize font-medium">{reminder.frequency}</div>
  
        <div class="text-gray-500">Time</div>
        <div>{reminder.time_of_day?.slice(0,5) || '—'}</div>
  
        <!-- {#if reminder.frequency === 'weekly'}
          <div class="text-gray-500">Day</div>
          <div>{reminder.day_of_week}</div>
        {/if} -->

        {#if reminder.frequency === 'weekly'}
            <div class="text-gray-500">Day</div>
            <div>{weekdays[(reminder.day_of_week + 6) % 7]}</div>
        {/if}
  
        {#if reminder.frequency === 'monthly'}
          <div class="text-gray-500">Day</div>
          <div>{reminder.day_of_month}</div>
        {/if}
  
        <div class="text-gray-500 col-span-2">Message</div>
        <div class="italic col-span-2">{reminder.custom_message}</div>
  
        <div class="text-gray-500">Timezone</div>
        <div>{reminder.timezone}</div>
  
        <div class="text-gray-500">Active</div>
        <div>{reminder.is_active ? 'Yes' : 'No'}</div>
      </div>
    {:else}
      <p class="text-sm text-gray-500">No reminder set.</p>
    {/if}
  
    <button class="btn btn-sm btn-outline w-full mt-4" on:click={triggerEdit}>
      {reminder ? 'Edit Reminder' : 'Add Reminder'}
    </button>
  {:else}
    <div class="space-y-4 mt-2">
      <div class="btn-group w-full mb-2">
        {#each ['daily', 'weekly', 'monthly'] as freq}
          <button
            class="btn btn-sm w-1/3"
            class:btn-active={localReminder.frequency === freq}
            on:click={() => localReminder.frequency = freq}>
            {freq.charAt(0).toUpperCase() + freq.slice(1)}
          </button>
        {/each}
      </div>
  
      {#if localReminder.frequency === 'weekly'}
        <div>
          <label class="label-text">Day of Week</label>
          <select class="select select-bordered w-full" bind:value={localReminder.day_of_week}>
            <option value="">Choose</option>
            {#each weekdays as day}
              <option value={day}>{day}</option>
            {/each}
          </select>
        </div>
      {/if}
  
      {#if localReminder.frequency === 'monthly'}
        <div>
          <label class="label-text">Day of Month</label>
          <select class="select select-bordered w-full" bind:value={localReminder.day_of_month}>
            <option value="">Choose</option>
            {#each monthDays as day}
              <option value={day}>{day}</option>
            {/each}
          </select>
        </div>
      {/if}
  
      <div>
        <label class="label-text">Time</label>
        <input type="time" class="input input-bordered w-full" bind:value={localReminder.time_of_day} />
      </div>
  
      <div>
        <label class="label">
          <span class="label-text">Time Zone</span>
        </label>
        <select bind:value={timezone} class="select select-bordered w-full">
          {#each timezones as tz}
            <option value={tz}>{tz}</option>
          {/each}
        </select>
        </div>


      <div>
        <label class="label-text">Custom Message</label>
        <input type="text" class="input input-bordered w-full" bind:value={localReminder.custom_message} />
      </div>
  
      <div>
        <label class="label-text">Webhook URL</label>
        <input type="url" class="input input-bordered w-full" bind:value={localReminder.teams_webhook_url} />
      </div>
  
      <div class="flex justify-between items-center">
        <span class="label-text">Active</span>
        <input type="checkbox" class="toggle" bind:checked={localReminder.is_active} />
      </div>
  
      <div class="flex gap-2 mt-2">
        <button class="btn btn-sm bg-[var(--aqua)] text-white w-1/2" on:click={triggerSave}>
          Save
        </button>
        <button class="btn btn-sm btn-ghost w-1/2" on:click={triggerCancel}>
          Cancel
        </button>
      </div>
     
    </div>
  {/if}